import _ from 'lodash'
import axios from 'axios'
// import 'bootstrap' // Optional, see notes below
// import $ from 'jquery' // Optional, see notes below

window._ = _
window.axios = axios

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

// If you need APP_URL at runtime from the server, use window.APP_URL fallback
window.APP_URL = import.meta.env.VITE_APP_URL || window.APP_URL

// Echo (optional - uncomment if using Laravel Echo + Pusher)
// import Echo from 'laravel-echo'
// import Pusher from 'pusher-js'

// window.Pusher = Pusher

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: import.meta.env.VITE_PUSHER_APP_KEY,
//     cluster: import.meta.env.VITE_PUSHER_

